import React from "react";

const CodeKey = (cell) => {
    return cell.value ? cell.value : '';
};


const titular = (cell) => {
    return cell.value ? cell.value : '';
};

const Name = (cell) => {
    return cell.value ? cell.value : '';
};

const Created_at = (cell) => {
    return cell.value ? cell.value : '';
};

const Active = (cell) => {
    return !cell.value ? <label className="text-white bg-danger text-center p-1" style={{width:'100%'}} >{'Baja'} </label>: <label className="text-center p-2" style={{backgroundColor:'green',color:"white", width:'100%'}}>{'Activo'}</label> ;
};

const Options = ({cell, onEdit}) => {
    return <div className="btn-group">
        <button className="btn btn-warning" onClick={() => onEdit(cell.row.original)}>Editar</button>
    </div>;
};

export {
    Name,
    Created_at,
    Active,
    Options
};
